import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaChevronDown, FaWhatsapp, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { AnimatePresence, motion } from "framer-motion";
import logo from "../Assets/logo1.png";
import BookingPopup from "./common/BookingPopup";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [pagesOpen, setPagesOpen] = useState(false);
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const pagesRef = useRef(null);

  /* ================= OUTSIDE CLICK ================= */
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pagesRef.current && !pagesRef.current.contains(e.target)) {
        setPagesOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  /* ================= NAVIGATION DATA ================= */
  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/tours", label: "Packages" },
    { to: "/services", label: "Services" },
    { to: "/transport-charges", label: "Charges" },
    { to: "/about", label: "Aboutus" },
    { to: "/khajuraho", label: "Khajuraho" },
    { to: "/scroll-gallery", label: "Gallery" },
    { to: "/news-media", label: "Blog" },
    { to: "/contact", label: "Contact" },
  ];

  const dropdownLinks = [
    { to: "/testimonials", label: "Testimonials" },
    { to: "/faqs", label: "Help Center" },
    { to: "/privacy-policy", label: "Privacy Policy" },
  ];

  return (
    <div className="w-full bg-white">
      {/* ================= TOPBAR (Solid & Professional) ================= */}
      <div className="hidden lg:block bg-gray-50 border-b border-gray-100 py-2.5">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8 flex justify-between items-center text-[12px] font-medium tracking-wide text-gray-600">
          <div className="flex items-center gap-8">
            <div className="flex gap-4">
              <a href="tel:+919993910094" className="flex items-center gap-2 hover:text-orange-main transition-colors">
                <FaPhoneAlt className="text-orange-main text-[10px]" />
                +91 99939 10094
              </a>
              <a href="tel:+919981980094" className="flex items-center gap-2 hover:text-orange-main transition-colors">
                <FaPhoneAlt className="text-orange-main text-[10px]" />
                +91 99819 80094
              </a>
            </div>
            <a href="mailto:khajurahoroutes@gmail.com" className="flex items-center gap-2 hover:text-orange-main transition-colors lowercase">
              <FaEnvelope className="text-orange-main text-[10px]" />
              khajurahoroutes@gmail.com
            </a>
          </div>
          <div className="flex items-center gap-5">
            <span className="text-gray-400">Follow Us</span>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/profile.php?id=100064103830605" target="_blank" rel="noreferrer" className="text-orange-main hover:text-orange-light transition-transform hover:scale-110"><FaFacebookF className="text-lg" /></a>
              <a href="https://www.instagram.com/routeskhajuraho/" target="_blank" rel="noreferrer" className="text-orange-main hover:text-orange-light transition-transform hover:scale-110"><FaInstagram className="text-lg" /></a>
              <a href="https://www.youtube.com/@khajurahoroutes8681" target="_blank" rel="noreferrer" className="text-orange-main hover:text-orange-light transition-transform hover:scale-110"><FaYoutube className="text-lg" /></a>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MAIN NAVIGATION (Solid White & Static) ================= */}
      <header className="bg-white border-b border-gray-100 relative z-[999]">
        <div className="max-w-[1440px] mx-auto px-4 lg:px-8 flex items-center justify-between h-[80px] lg:h-[95px]">

      {/* BRANDING (Logo + Tagline) */}
<Link to="/" className="flex flex-col items-start">
  <div className="w-32 lg:w-56 h-auto">
    <img
      src={logo}
      alt="Khajuraho Routes Official Logo"
      className="w-full object-contain"
    />
  </div>

  {/* Tagline */}
  <p
    className="text-[11px] lg:text-base text-gray-600 mt-1 italic tracking-wide pl-6 ml-8 lg:ml-8"
    style={{ fontFamily: "'Brush Script MT', cursive" }}
  >
    A Journey Awaits You
  </p>
</Link>
          {/* DESKTOP NAV */}
          <nav className="hidden lg:flex items-center gap-4 xl:gap-8">
            <ul className="flex items-center gap-4 xl:gap-7">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <NavLink
                    to={link.to}
                    className={({ isActive }) => `
                      relative py-2 text-[14px] xl:text-[18px] font-bold transition-all duration-300 whitespace-nowrap
                      ${isActive ? "text-orange-main" : "text-gray-700 hover:text-orange-main"}
                    `}
                  >
                    {link.label}
                  </NavLink>
                </li>
              ))}

              {/* DROPDOWN */}
              {/* <li className="relative" ref={pagesRef}>
                <button
                  onClick={() => setPagesOpen(!pagesOpen)}
                  className={`flex items-center gap-1.5 text-[15px] font-bold text-gray-700 hover:text-orange-main transition-colors ${pagesOpen ? "text-orange-main" : ""}`}
                >
                  Explore
                  <FaChevronDown className={`text-[10px] transition-transform duration-300 ${pagesOpen ? "rotate-180" : ""}`} />
                </button>

                <AnimatePresence>
                  {pagesOpen && (
                    <motion.div
                      initial={{ opacity: 0, y: 15 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      className="absolute right-0 top-full mt-4 w-56 bg-white rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.15)] overflow-hidden p-2 border border-gray-100"
                    >
                      {dropdownLinks.map((link) => (
                        <NavLink
                          key={link.to}
                          to={link.to}
                          onClick={() => setPagesOpen(false)}
                          className={({ isActive }) => `
                            block px-5 py-3 rounded-xl text-[14px] font-semibold transition-all
                            ${isActive ? "bg-orange-main text-white" : "text-gray-700 hover:bg-gray-50 hover:text-orange-main"}
                          `}
                        >
                          {link.label}
                        </NavLink>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </li> */}
            </ul>

            {/* ACTION BUTTONS */}
            <div className="flex items-center gap-4 xl:gap-6 ml-2 xl:ml-4 border-l border-gray-200 pl-4 xl:pl-8">
              {/* <a 
                href="https://wa.me/919993910094" 
                target="_blank" 
                rel="noreferrer"
                className="w-11 h-11 rounded-full bg-teal-main/10 flex items-center justify-center text-teal-main hover:bg-teal-main hover:text-white transition-all duration-300 shadow-sm"
               >
                 <FaWhatsapp className="text-2xl" />
               </a> */}
              <button
                onClick={() => setIsBookingOpen(true)}
                className="
                  bg-orange-main text-white px-7 py-3 rounded-full font-bold text-[12px] uppercase tracking-wider
                  shadow-lg shadow-orange-main/20
                  hover:bg-orange-light hover:-translate-y-0.5 active:translate-y-0
                  transition-all duration-300
                "
              >
                Book Package
              </button>
            </div>
          </nav>

          {/* MOBILE TOGGLE */}
          <div className="lg:hidden flex items-center gap-4">
            <a href="tel:+919993910094" className="w-10 h-10 rounded-full bg-orange-main/10 flex items-center justify-center text-orange-main">
              <FaPhoneAlt className="text-sm" />
            </a>
            <button
              onClick={() => setMenuOpen(true)}
              className="w-12 h-12 rounded-2xl bg-gray-50 flex flex-col items-center justify-center gap-1.5 transition-colors"
            >
              <span className="w-7 h-0.5 bg-gray-900 rounded-full" />
              <span className="w-7 h-0.5 bg-orange-main rounded-full self-start ml-2" />
              <span className="w-7 h-0.5 bg-gray-900 rounded-full" />
            </button>
          </div>
        </div>
      </header>

      {/* ================= MOBILE MENU ================= */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: "100%" }}
            className="fixed inset-0 z-[99999] bg-white flex flex-col"
          >
            <div className="flex justify-between items-center px-8 py-6 border-b border-gray-50">
              <img src={logo} alt="Khajuraho Routes Travel Agency Logo" className="h-10 w-auto" />
              <button
                onClick={() => setMenuOpen(false)}
                className="w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center text-gray-900 hover:bg-orange-main hover:text-white transition-all shadow-sm"
              >
                <FaTimes className="text-lg" />
              </button>
            </div>

            <div className="flex-1 overflow-y-auto no-scrollbar px-10 py-8 flex flex-col gap-1">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) => `
                    block py-3 text-[22px] font-black tracking-tight transition-all
                    ${isActive ? "text-orange-main" : "text-gray-900"}
                  `}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>

            <div className="p-8 border-t border-gray-100 bg-white flex justify-center">
              <button
                onClick={() => {
                  setMenuOpen(false);
                  setIsBookingOpen(true);
                }}
                className="w-[85%] bg-orange-main text-white py-4 rounded-2xl font-bold text-center shadow-xl shadow-orange-main/20 text-sm uppercase tracking-wider"
              >
                Book Package
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <BookingPopup isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
    </div>
  );
};

export default Header;
